"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignmentTypeDropdown = void 0;
const react_1 = __importDefault(require("react"));
const common_1 = require("../../../../../common");
const GlobalStateProvider_1 = require("../../../../../GlobalStateProvider");
const TYPE_DROPDOWN_LIST = [
    { id: 'select', title: 'assignment.questionType' },
    { id: 'OMR', title: 'assignment.OMR' },
    { id: 'OMR-free', title: 'assignment.OMR-free' },
    { id: 'attachment', title: 'assignment.attachment' },
    { id: 'survey', title: 'assignment.survey' },
];
exports.AssignmentTypeDropdown = react_1.default.memo(({ type, setType }) => {
    const { isTablet, isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    const [value, setValue] = react_1.default.useState({
        id: 'select',
        title: 'assignment.questionType',
    });
    react_1.default.useEffect(() => {
        if (type !== value.id)
            setValue(TYPE_DROPDOWN_LIST.find(item => item.id === type));
    }, [type]);
    const handlerUpdateDrop = (item) => {
        setType(item.id);
        setValue(item);
    };
    return (react_1.default.createElement(common_1.DropDown, { className: "dropdown-tablet-small", value: value, list: TYPE_DROPDOWN_LIST, styles: {
            ...(isMobile ? {} : { dropWrap: { width: isTablet ? 140 : 150 } }),
            itemWrap: {
                top: isTablet ? '50px' : '45px',
            },
        }, setDropValue: handlerUpdateDrop }));
});
